import React from "react";

interface CustomFormContextInterface {
  isLoading: boolean;
  formError: string;
}

export const CustomFormContext =
  React.createContext<CustomFormContextInterface>({
    isLoading: false,
    formError: "",
  });

export const useCustomFormContext = () => {
  const context = React.useContext(CustomFormContext);
  if (context === undefined) {
    throw new Error("useCustomFormContext must be used within a FormProvider");
  }
  return context;
};
